import styled from 'styled-components';

export const WrapperFilter = styled.div`
  .sb-filter__top--title {
    color: #4f6168;
  }
  .sb-filter__top:hover {
    border-color: #745ef6;
  }
  .sb-checkfield label {
    color: #161d1f !important;
    padding-top: 1.2rem;
    padding-bottom: 1.2rem;
  }
  .sb-filter__bottom--option {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-right: 0px !important;
  }
  .sb-filter__bottom--option > div.sb-checkfield--disabled label {
    color: #8090bb !important;
    > input {
      border: 1px solid #d5e5f0 !important;
    }
  }
  .sb-filter__label {
    font-weight: 400;
    font-family: 'lato';
    color: #161d1f;
  }
  .sb-filter__bottom--firstoption {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    padding-right: 0px !important;
  }
  .sb-filter__bottom--option--selected {
    background-color: #e2dffd;
  }
  .sb-filter__bottom--option:hover,
  .sb-filter__bottom--firstoption:hover {
    background-color: #d5e5f0;
  }
  .sb-filter__bottom--option:has(> .sb-checkfield--primary input:focus),
  .sb-filter__bottom--firstoption:has(> .sb-checkfield--primary input:focus) {
    background-color: #a8cbe2;
  }
  .sb-checkfield--primary input:focus {
    outline: none;
  }
  .sb-checkfield--primary input:hover,
  .sb-checkfield--primary input:checked {
    border-color: #7a959f;
  }
  .sb-filter__top {
    border-color: #4318cd;
  }
  .sb-icon.text-primary-60 {
    color: #5b36f2;
    border-radius: 4px;
    padding: 5px;
    &:hover {
      background-color: #e2dffd;
    }
  }
  .sb-filter__bottom {
    position: absolute;
    width: calc(100% - 90px);
    z-index: 9;
    overflow-y: auto;
    max-height: 230px;
  }
  .sb-checkfield--primary input[type='checkbox']:checked:before {
    background-color: #5b36f2;
  }
`;
